import FieldEmail from "../../Form/Fields/FieldEmail";
import FieldInput from "../../Form/Fields/FieldInput";
import MarginChildren from "../../Helper/MarginChildren";
import React from "react";
import translate from "../../../Utils/translate";

const UserInfo = ({ formik }) => {
  return (
    <MarginChildren>
      <FieldInput
        autoComplete="register-new-user-username"
        errors={formik.errors}
        name="username"
        onBlur={formik.handleBlur}
        onChange={formik.handleChange}
        placeholder={translate("forms.username.placeholder")}
        required={true}
        touched={formik.touched}
        value={formik.values?.username}
      />
      <FieldEmail
        autoComplete="recoveryEmail"
        errors={formik.errors}
        name="recoveryEmail"
        onBlur={formik.handleBlur}
        onChange={formik.handleChange}
        placeholder={translate("forms.recovery_email.placeholder")}
        required={true}
        touched={formik.touched}
        value={formik.values?.recoveryEmail}
      />
    </MarginChildren>
  );
};

export default UserInfo;
